// extracted by mini-css-extract-plugin
export default {"holder":"classButton_holder__48b6j","thumbnail":"classButton_thumbnail__Mzcd9","para":"classButton_para__KQ7x6"};